import gql from 'graphql-tag';

export default gql`
  mutation ($_id: MongoID!, $name: String, $description: String, $index: Float, $status: EnumContentGroupStatus) {
    updateContentGroup(_id: $_id, record: { name: $name, description: $description, index: $index, status: $status }) {
      recordId
    }
  }
`;
